import { useQuery } from "react-query";
import { CampaignRequest } from "../../../../apis/campaign/CampaignRequest";

const GetUser = () => {
  const { data, isLoading } = useQuery(
    ["GetUser"],
    () => CampaignRequest.getUser(),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    }
  );

  return {
    data,
    isLoading,
  };
};

export default GetUser;
